// Put these small SVG components near the top of your file (no extra imports needed)
export const OutlinePlayIcon = (props) => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" {...props}>
    {/* triangle outline */}
    <polygon points="9,7 9,17 17,12" />
  </svg>
);

export const OutlinePauseIcon = (props) => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
    <rect x="7"  y="6" width="3.2" height="12" rx="1" />
    <rect x="13.8" y="6" width="3.2" height="12" rx="1" />
  </svg>
);
export const drag = (color) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 14 14" fill="none">
    <path
      d="M11.0833 1.75H2.91667C2.27233 1.75 1.75 2.27233 1.75 2.91667V11.0833C1.75 11.7277 2.27233 12.25 2.91667 12.25H11.0833C11.7277 12.25 12.25 11.7277 12.25 11.0833V2.91667C12.25 2.27233 11.7277 1.75 11.0833 1.75Z"
      stroke={color}
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 1.75V12.25"
      stroke={color}
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const menu=<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M6.99998 4.1999C6.62867 4.1999 6.27258 4.0524 6.01003 3.78985C5.74748 3.5273 5.59998 3.17121 5.59998 2.7999C5.59998 2.4286 5.74748 2.0725 6.01003 1.80995C6.27258 1.5474 6.62867 1.3999 6.99998 1.3999C7.37128 1.3999 7.72737 1.5474 7.98992 1.80995C8.25248 2.0725 8.39998 2.4286 8.39998 2.7999C8.39998 3.17121 8.25248 3.5273 7.98992 3.78985C7.72737 4.0524 7.37128 4.1999 6.99998 4.1999ZM6.99998 8.3999C6.62867 8.3999 6.27258 8.2524 6.01003 7.98985C5.74748 7.7273 5.59998 7.37121 5.59998 6.9999C5.59998 6.6286 5.74748 6.2725 6.01003 6.00995C6.27258 5.7474 6.62867 5.5999 6.99998 5.5999C7.37128 5.5999 7.72737 5.7474 7.98992 6.00995C8.25248 6.2725 8.39998 6.6286 8.39998 6.9999C8.39998 7.37121 8.25248 7.7273 7.98992 7.98985C7.72737 8.2524 7.37128 8.3999 6.99998 8.3999ZM6.99998 12.5999C6.62867 12.5999 6.27258 12.4524 6.01003 12.1899C5.74748 11.9273 5.59998 11.5712 5.59998 11.1999C5.59998 10.8286 5.74748 10.4725 6.01003 10.21C6.27258 9.9474 6.62867 9.7999 6.99998 9.7999C7.37128 9.7999 7.72737 9.9474 7.98992 10.21C8.25248 10.4725 8.39998 10.8286 8.39998 11.1999C8.39998 11.5712 8.25248 11.9273 7.98992 12.1899C7.72737 12.4524 7.37128 12.5999 6.99998 12.5999Z" fill="#7E7E7E"/>
</svg>